define('_views/Navigation',[
	'text!_templates/navigation.html'
],
function(
	template
) {
	return Backbone.View.extend({
		template: _.template(template),

		events: {

		},

		initialize: function() {
			Backstage.Collection.fanCollection.on('all', this.updateFanCounts, this);
			Backstage.Collection.fanOfCollection.on('all', this.updateFanCounts, this);
		},

		render: function(){
			this.$el.html(
				this.template({
					fan_count : Backstage.Collection.fanCollection.length,
					fanof_count : Backstage.Collection.fanOfCollection.length
				})
			);

			return this;
		},

		updateFanCounts: function() {
			this.$el.find('[data-fans-count]').text(Backstage.Collection.fanCollection.length);
			this.$el.find('[data-fan-of-count]').text(Backstage.Collection.fanOfCollection.length);
		},
		
		setActive: function(section) {
			this.$el.find('[data-destination]').removeClass('active');
			$('[data-destination="'+section+'"]').addClass('active');
		}
	});
});

